import axios from 'axios'
import store from '@/store'
import router from '@/router'

function isOnLoginRoute() {
  const current = router.currentRoute
  if (!current) return false
  return current.name === 'login' || current.path === '/'
}

function handleSessionInvalid() {
  store.commit('setData', {
    token: '',
    username: '',
    role: '',
    expiresIn: '',
    isAuthenticated: false,
  })

  if (!isOnLoginRoute()) {
    router.push('/').catch(() => {})
  }
}

export default () => {
  const instance = axios.create({
    baseURL: `https://sandbox.ica.complement-it.com/api/`,
    timeout: 600000,
  })

  instance.interceptors.request.use(
    (config) => {
      const token = store.state.token
      if (token) {
        config.headers = config.headers || {}
        config.headers.Authorization = `Bearer ${token}`
      } else if (config.headers) {
        delete config.headers.Authorization
      }
      return config
    },
    (error) => Promise.reject(error)
  )

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response && error.response.status
      const data = error.response && error.response.data

      if (
        status === 401 &&
        (
          (data && data.valid === false) ||
          (data && (data.reason === 'session_closed' || data.reason === 'no_token'))
        )
      ) {
        handleSessionInvalid()
      }

      if (status === 401 && !isOnLoginRoute()) {
        if (store.state.token && !store.state.isAuthenticated) {
          handleSessionInvalid()
        }
      }

      return Promise.reject(error)
    }
  )

  return instance
}
